<!--
  style="flex: 1; margin-left: 2rem"
-->
<div>
  <div class="location-radio-buttons">
    <div class="location-title">Montageort</div>
    <div>
      <mat-radio-group [value]="loctype" (change)="onLocationChange($event)"
      [disabled]="readonly">
        <mat-radio-button class="edit-orders-location-radio" [value]="0"
          >Kundenwohnort</mat-radio-button
        >
        <mat-radio-button class="edit-orders-location-radio" [value]="1"
          >MAG-Werkstatt</mat-radio-button
        >
        <mat-radio-button class="edit-orders-location-radio" [value]="2"
          >anderer Ort</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
  <div *ngIf="loctype == 2" style="margin-bottom: 4px">
    <app-input
      label="Straße"
      #montageAddress
      [required]="true"
      [(value)]="_data.montage_address"
      name="montageAddress"
      [readonly]="readonly"
      [maxlength]="addressLength"
    ></app-input>
    <div class="row-layout">
      <div>
        <app-input
          label="PLZ"
          #montageZip
          [(value)]="_data.montage_zip"
          name="montageZip"
          [readonly]="readonly"
          [maxlength]="zipLength"
        ></app-input>
      </div>
      <div style="flex: 1; margin-left: 1rem">
        <app-input
          label="Stadt"
          #montageCity
          [required]="true"
          [(value)]="_data.montage_city"
          name="montageCity"
          [readonly]="readonly"
          [maxlength]="cityLength"
        ></app-input>
      </div>
    </div>
  </div>
</div>
